import React from 'react'
import { DropButton, Box } from 'grommet'
import { CircleInformation } from 'grommet-icons'

const InfoButton = ({
  content,
  width = '25rem',
  position = 'top',
  background = 'baseBackground',
  padding = '6px',
  icon = <CircleInformation size="xsmall" color="iconDarkLight" />,
}) => {
  const dropAlign = position === 'top' ? { bottom: 'top' } : { top: 'bottom' }
  return (
    <DropButton
      icon={icon}
      dropAlign={dropAlign}
      style={{ padding: padding }}
      dropProps={{
        background: background,
        stretch: false,
        width: width,
        pad: '1rem',
        elevation: 'medium',
      }}
      dropContent={<Box>{content}</Box>}
    />
  )
}

export default InfoButton
